export default function isAnyChecked(
    selectTextualReport,
    selectCSVInputData
  ) {
    return (
      selectTextualReport ||
      selectCSVInputData
    );
  }
  